// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10XKr","input":"styles_input__1UWks"};